module.exports = __webpack_public_path__ + "img/arrow_back_muted.afde522b.svg";